import React from 'react';
import { Grid } from '@material-ui/core';
import { Bar } from 'react-chartjs-2';

import Card from 'src/components/sharedComponents/Card/Card';
import CardBody from 'src/components/sharedComponents/Card/CardBody';
import CardHeader from 'src/components/sharedComponents/Card/CardHeader';
import * as Utils from 'src/utils/chartsUtils';

import { useStyles } from '../styles';
import TableAA from '../../Tables/TableAA';
import TableAAPP from '../../Tables/TableAAPP';

const TotalEasyToDriverCard = (props) => {
  const {
    titleCard = '',
    paramAAPP = '',
    arrayTableAA = [],
    selectedDate,
    arrayTableAAPP = [],
    arrayGraphBar = [],
    arrayGraphA = [],
    arrayGraphB = [],
    pramGraphs = 'y',
  } = props;
  const classes = useStyles();
  return (
    <Card>
      <CardHeader>
        <div className={classes.center}>
          <div>
            <h3>{titleCard}</h3>
          </div>
          {'  '}
        </div>
      </CardHeader>
      <CardBody>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} lg={6}>
            <TableAA
              array={arrayTableAA}
              selectedDate={selectedDate}
              disableAA
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Evolución en miles</h3>
            <br />
            <Bar
              data={Utils.simpleBarLine(
                arrayGraphBar,
                'Y',
                'CANT',
                'VARIACION',
                'Año',
              )}
              options={Utils.optionsSimpleBarChart}
            />
            {' '}
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} lg={12}>
              <br />
              <TableAAPP
                array={arrayTableAAPP}
                param={paramAAPP}
                selectedDate={selectedDate}
                title="Segmento"
                AA
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={6}>
              <h3>Evolución por segmento año</h3>
              <br />
              <Bar
                data={Utils.barLineDataGroup(arrayGraphA, pramGraphs)}
                options={Utils.optionsGroupedCharts}
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={6}>
              <h3>Evolución por segmento mes</h3>
              <br />
              <Bar
                data={Utils.barLineDataGroup(arrayGraphB, 'MES')}
                options={Utils.optionsGroupedCharts}
              />
            </Grid>
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  );
};

export default TotalEasyToDriverCard;
